(function () {
  const $formCustomizacao = $('.form-customizacao');
  const $cardDigitavel = $('.digitavel');
  if ($formCustomizacao.length > 0) {
    const $inputType = $('input[name="type"]');

    function startType() {
      // var type = $inputType.find('[checked]').val();
      var type = $('input[name="type"][checked]').val();
      $(`.${type}`).addClass('show');

      atualizaFormRequired();
    }
    startType();

    function atualizaFormRequired() {
      // Remove required
      // $(`.type_change`).not('.show').find('input[required]').prop('required', '');
      $(`.type_change`)
        .not('.show')
        .find('input[data-required="true"]')
        .prop('disabled', 'disabled')
        .prop('required', '');
      $(`.type_change.show`).find('input[data-required="true"]').prop('required', 'required').prop('disabled', '');
      $formCustomizacao.parsley().reset();
    }

    // Configurações iniciais

    $inputType.on('change', inputTypeChange);
    function inputTypeChange(e) {
      const type = $(this).val();
      $(`.${type}`).addClass('show');
      $(`.type_change:not(.${type})`).removeClass('show');

      atualizaFormRequired();
    }

    $cardDigitavel.find('input[type="radio"]').on('change', inputRadioDigitavelChange);
    function inputRadioDigitavelChange(ev) {
      const currentValue = $(this).val();
      // $('input[type="hidden"][name="values"]').val(currentValue);
    }
  }
})();
